import { GridAggregationFunction } from '@mui/x-data-grid-premium';
import { dateSort } from 'shared/utils/DateTime';

export const maxDateAggregation: GridAggregationFunction<string, string | null> = {
  apply: ({ values }) => {
    const sorted = values.sort(dateSort);

    return sorted[0];
  },
  label: 'maxDate',
  columnTypes: ['date'],
};

export const dashDiffAggregation: GridAggregationFunction<string, string | null> = {
  apply: (params) => {
    const [first, ...rest] = params.values;

    if (rest.length > 0 && rest.some((value) => value !== first)) {
      return '--';
    }

    return first;
  },
  label: 'dashDiff',
  columnTypes: ['string'],
};

export const totalsLabelAggregation: GridAggregationFunction<string, string | null> = {
  apply: () => 'TOTALS:',
  label: 'totals',
};
